// Libs
import React from 'react'
import classNames from 'classnames'

// CSS
import "./styles.scss"

// Components/Containers
import LoadingIcon from '../LoadingIcon'

const LoadingBox = () => {
  return (
    <div className="loading-box">
      <LoadingIcon type="grey" size={13} spaceBetweenDots={4} />
    </div>
  )
}

export default LoadingBox
